(function() {
	"use strict";

	angular.module("swurveys.maker")
		.factory("referralModal", Handler);



	function Handler(ModalService) {
		return {
			show: function(user) {
				return ModalService.showModal({
					templateUrl: "app/modals/refer/refer.html",
					controller: ["$element", "close", function($element, close) {
						var modal = this;
						modal.user = user;
						console.log("modal user", user);
						this.close = function(confirm) {
							close(confirm, 500);
							$(".modal-backdrop")
								.remove();
						};
					}],
					controllerAs: "modal"
				});
			}
		};
	};
}());
